import { Loader } from '@consta/uikit/Loader'
import type { ComponentProps, FC } from 'react'

import css from './CenteredLoader.css'

type CenteredLoaderProps = ComponentProps<typeof Loader>

export const CenteredLoader: FC<CenteredLoaderProps> = props => {
  return (
    <div className={css.container}>
      <Loader {...props} />
    </div>
  )
}
